import React from "react";
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "react-oidc-context";
import { InitialAccountDataStorageKey } from '../../constants/localStorage';

const PersonaAccountRegistrationPage = ({submitHandler, prevPage}) => {
    const manageData = JSON.parse(localStorage.getItem(InitialAccountDataStorageKey));
    const auth = useAuth();
    const redirectUri = window.location.href.replace('personaAccountRegistrationPage', '3');
    const authParams = {
        acr_values: `first:${manageData.firstName} last:${manageData.lastName} brand:dcg partner_invite:true`,
        login_hint: `${manageData.email}`,
        redirect_uri: redirectUri
    }

    if (auth?.user?.access_token
        && auth?.user?.profile?.sub
        && auth?.isAuthenticated) {
            submitHandler();
    }
    else {
        auth.signinRedirect(authParams);
    }

    return (
        <div>Registering...</div>
    )
}

export default PersonaAccountRegistrationPage;